import React from 'react';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Tooltip } from '@mui/material';

import StatusTag from 'pages/item/v2/components/CpeConfigurations/components/StatusTag';
import useCpeMatchParameters from 'pages/item/v2/components/CpeConfigurations/hooks/use-cpe-match-parameters';

import useStyles from './styles';

import { CpeMatchItem as CpeMatchItemInterface } from '../../types';
import Tag from '../Tag';

interface Props {
    data: CpeMatchItemInterface;
    className?: string;
}

const CpeMatch: React.FC<Props> = ({ data, className }) => {
    const { classes, cx } = useStyles();
    const {
        vendor,
        product,
        version,
        update,
        edition,
        language,
        swEdition,
        targetSw,
        targetHw,
        vulnerable,
        criteria
    } = useCpeMatchParameters(data);

    return (
        <div className={cx(classes.root, className)}>
            {vendor ? <Tag label={vendor} tooltip="Vendor" /> : null}
            {product ? <Tag label={product} tooltip="Product" /> : null}
            {version ? (
                typeof version === 'string' ? (
                    <>
                        <Tag label="Match" />
                        <Tag label={version} tooltip="Version" />
                    </>
                ) : (
                    <>
                        <Tag label="Range" color="blue" tooltip="Version" />
                        {version.begin ? (
                            <Tag
                                label={version.begin.value}
                                tooltip={`Version (${version.begin.inclusive ? 'Inclusive' : 'Exclusive'})`}
                            />
                        ) : null}
                        {version.operator}
                        {version.end ? (
                            <Tag
                                label={version.end.value}
                                tooltip={`Version (${version.end.inclusive ? 'Inclusive' : 'Exclusive'})`}
                            />
                        ) : null}
                    </>
                )
            ) : null}
            {update ? <Tag label={update} tooltip="Update" /> : null}
            {edition ? <Tag label={edition} tooltip="Edition" /> : null}
            {language ? <Tag label={language} tooltip="Language" /> : null}
            {swEdition ? <Tag label={swEdition} tooltip="Software Edition" /> : null}
            {targetSw ? <Tag label={targetSw} tooltip="Target Software" /> : null}
            {targetHw ? <Tag label={targetHw} tooltip="Target Hardware" /> : null}
            {vulnerable ? (
                <StatusTag color="red" tooltip="Vulnerable" />
            ) : (
                <StatusTag color="green" tooltip="Non-vulnerable" />
            )}
            <Tooltip title={criteria}>
                <ErrorOutlineIcon color="inherit" className={classes.criteria} />
            </Tooltip>
        </div>
    );
};

export default CpeMatch;
